import { appendPreferences } from "utils/preferenceBuilder";

const createFormData = (organization) => {
    const {profile_tabs, preferences} = organization;
    const formData = new FormData();

    appendPreferences(formData, preferences);

    profile_tabs.forEach(tab => {
      formData.append('profile_tabs[]', tab);
    })

    return formData;
  };

  export default createFormData;
